import {
  defineNuxtPlugin,
  addRouteMiddleware
} from '#app'

export default defineNuxtPlugin(() => {
  addRouteMiddleware(
    'global-auth',
    async (to) => {
      if (
        to.path.includes('login') ||
        to.path.includes('auth')
      ) {
        return true
      } else {
        const { $get } = useApi()
        const userStore = useUserStore()

        // try {
        //   let localUser = userStore.user
        //   if (!localUser) { localUser = await $get('/api/v1/auth') }
        //   if (userStore?.setUser) { userStore.setUser(localUser) }

        //   // @ts-ignore
        // } catch (error) {
        //   // console.error(error)
        // }
      }
    },
    { global: true }
  )
})
